'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.open-data').config(translationsConfig);

    /* @ngInject */
    function translationsConfig($translateProvider) {

        $translateProvider.translations('en-US', {
            'front-page': {
                'The city': 'The city',
                'citizens': 'citizens',
                'citizens since': 'citizens since {{date | date: "yyyy"}}',
                'residents': 'residents',
                'The citizens': 'The citizens',
                'weddings': 'weddings',
                'divorces': 'divorces',
                'Weather conditions': 'Weather conditions'
            },
            'open-data': {
                'Municipal open data': 'Municipal open data',
                'Municipal Roll': 'Municipal Roll',
                'Civil Register': 'Civil Register',
                'Open Data': 'Open Data',
                'Fiscal data': 'Fiscal data',
                'Datasets': 'Datasets',
                'Library': 'Vikelaia Library',
                'Social service': 'Social service',
                'Date': 'Date',

                'dataset-url-attr': 'url_en',
                'dataset-name-attr': 'name_en',

                'download-button': {
                    'Download': 'Download',
                    'CSV file': 'CSV file',
                    'Image': 'Image',
                    'Vector image': 'Vector image'
                },

                'see more': 'more',

                'widgets': {
                    'the-city': {
                        'The City': 'The city',

                        'phrase:population': 'In <em>{{date | date:"yyyy"}}</em> the number of residents was <em>{{residents | number}}</em> which was <em>changed by {{increase | number}}</em> since {{last_date | date: "yyyy"}}.',
                        'phrase:population-relocations': 'During that year the city welcomed <em>{{inbound}} new citizens</em> but in the same period <em>{{outbound}} moved away</em>.',
                        'phrase:population-voters': 'The number of <em>registered voters</em> was <em>{{voters | number}}</em>.',

                        'see more': 'see more'
                    },
                    'the-citizens': {
                        'The Citizens': 'The citizens',

                        'phrase:citizens-good-news': 'In the <em>first semester of {{date | date:"yyyy"}}</em>, <em>{{weddings}}</em> couples got <em>married</em> and the municipality grew larger by <em>{{births}} baby citizens.</em>',
                        'phrase:citizens-bad-news': 'On the other hand, <em>{{divorces}} couples divorced</em> and <em>{{deaths}} citizens died</em>.',

                        'see more': 'see more'
                    },
                    'budget': {
                        'Budget execution': 'Budget execution {{year}}',

                        'phrase:summary': '<em>Revenue {{revenue.collected | number}}&euro;</em> (including {{remainder.collected | number}}&euro; reserve fund)<br/><em>Expenses {{expenses.paid | number}}&euro;</em>',

                        'see more': 'see more'
                    }
                }

            },
            'civil-register': {

                'api-i18n:name': 'name_en',

                'The citizens': 'The citizens',
                'births': 'births',
                'deaths': 'deaths',
                'divorces': 'divorces',
                'weddings': 'weddings',

                'Date': 'Date',
                'Civil Register': 'Civil Register',
                'Grouped': 'Grouped',
                'Stacked': 'Stacked',
                'Category': 'Category',
                'Start Year': 'Start',
                'End Year': 'End',
                'Male births': 'Male births',
                'Female births': 'Female births',
                'Male deaths': 'Male deaths',
                'Female deaths': 'Female deaths',
                'Religious weddings': 'Religious weddings',
                'Civil weddings': 'Civil weddings',
                'Civil unions': 'Civil unions',
                'Divorces': 'Divorces',
                '1st Semester': '1st Semester',
                '2nd Semester': '2nd Semester',

                'ui:filename': 'Civil register - {{category}} {{fromYear}} from {{toYear}}.{{extension}}'

            },
            'fiscal-data': {
                'Fiscal data': 'Fiscal data',
                'Budget execution': 'Budget execution',
                'Revenue': 'Revenue',
                'Remainder': 'Reserve fund',
                'Expenses': 'Expenses',
                'Start Year': 'Start Year',
                'End Year': 'End Year',
                'Codes': 'Codes',
                'Show analysis': 'Show analysis',
                'Hide analysis': 'Hide analysis',

                'Grouped': 'Grouped',
                'Stacked': 'Stacked',
                'Expanded': 'Expanded',
                'Total': 'Total'

            },
            'municipal-roll': {
                'Date': 'Date',
                'Municipal Roll': 'Municipal Roll',
                'Start Year': 'Start',
                'End Year': 'End',
                'Residents': 'Residents',
                'Registered voters': 'Registered voters',
                'Outbound residents': 'Registration transfers from the Municipality',
                'Inbound residents': 'Registration transfers from the Municipality',
                'Foreigner inbound residents': 'Number of foreigners that became citizens',

                'Grouped': 'Grouped',
                'Stacked': 'Stacked',

                'ui:filename': 'Municipal roll from {{fromYear}} to {{toYear}}.{{extension}}'

            },
            'library': {
                'Library': 'Vikelaia Library',
                'Start Year': 'Start Year',
                'End Year': 'End Year',
                'Date': 'Date',

                'Members': 'Members',
                'Total books': 'Number of books',
                'Books for lending': 'Books for lending',
                'Lended books': 'Lendings',

                'book titles': 'book titles',
                'lendings': 'lendings',
                'members': 'members',

                '1st Semester': '1ο semester',
                '2nd Semester': '2ο semester',

                'phrase:description': 'Vikelaia Library has <em>{{members | number}} registered members</em>. The Library accommodates <em>{{total_books | number}} book titles</em> <em>{{books_for_lending | number}}</em> of which are available for lending.<br/>It\'s members have <em>borrowed {{lended_books | number}} books</em> during the {{semester == 1 ? \'1st\':\'2nd\'}} semester of {{date | date:\'yyyy\'}}.',

                'ui:filename': 'Vikelaia Library from {{fromYear}} to {{toYear}}.{{extension}}'
            },

            'social-service': {
                'Social service': 'Social service',
                'Start Year': 'Start Year',
                'End Year': 'End Year',
                'Date': 'Date',

                '1st Semester': '1ο semester',
                '2nd Semester': '2ο semester',

                'Number of funded social programs': 'Funded social programs',
                'Social service benefiters': 'Social service benefiters',
                'Ergotherapy benefiters': 'Ergotherapy benefiters',
                'Medical service benefiters': 'Medical service benefiters',
                'Physiotherapy benefiters': 'Physiotherapy benefiters',
                'Obstetrics benefiters': 'Obstetrics benefiters',
                'Allowance policy benefiters': 'Allowance policy benefiters',
                'Municipal clinics benefiters': 'Municipal clinics benefiters',
                'Social grocery benefiters': 'Social grocery benefiters',
                'Homeless center benefiters': 'Homeless center benefiters',
                'FEAD benefiters': 'FEAD benefiters',

                'ui:filename': 'Social service from {{fromYear}} to {{toYear}}.{{extension}}'
            }
        });
    }
})();